import z from 'zod';
import { aliasCodec, zAlias } from '../../../modules/shared/zod.helpers';

const BaseUserInfoSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  language: z.string(),
  sellerId: z.string().nullish(),
  groupId: z.string().nullable(),
  theme: z.string(),
  allowCurrentDay: z.boolean(),
  organizationIds: z.array(z.string()).nullish(),
  operationIds: z.array(z.string()),
  adminAccess: z.boolean().nullish(), // null for users created without the flag (directory has no default)
  installerAccess: z.boolean().optional(),
  sellerAccess: z.boolean().optional(),
  managerAccess: z.boolean().optional(),
  groupAccess: z.boolean().optional(),
  analyticsAccess: z.boolean().optional()
});

export const UserInfoSchema = aliasCodec(BaseUserInfoSchema, {
  first_name: 'firstName',
  last_name: 'lastName',
  seller_id: 'sellerId',
  retail_group_id: 'groupId',
  store_analytics_template: 'theme',
  reporting_api_allow_current_day: 'allowCurrentDay',
  organization_ids: 'organizationIds',
  operation_ids: 'operationIds',
  admin_access: 'adminAccess',
  installer_access: 'installerAccess',
  seller_access: 'sellerAccess',
  manager_access: 'managerAccess',
  retail_group_access: 'groupAccess',
  store_analytics_access: 'analyticsAccess'
});

export type UserInfo = z.infer<typeof UserInfoSchema>;
